import { render, staticRenderFns } from "./AdminVipGroupCreateButton.vue?vue&type=template&id=302f7d84&"
import script from "./AdminVipGroupCreateButton.vue?vue&type=script&lang=ts&"
export * from "./AdminVipGroupCreateButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QTooltip});
